export default __webpack_public_path__ + "static/media/Submiticon.f5165e25.svg";